import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { WORKSHOPS_OPTIONS, EventResponse } from '../../../constants';
import EventListView from '../../searchResult';
import { Creators as eventScrollActions } from '../../../../../../domain/useCases/events/getEventsUseCase/getEventsByStudentScroll';

interface WorkshopsBodyViewProps {
  current: number;
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number, typeEvent: string) => void;
  tabTitle: string;
}

const Workshops = (props: WorkshopsBodyViewProps) => {
  const { current, handleTab, selectEvent, tabTitle } = props;
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();

  const { data, showMore, isLoading } = useSelector(
    (state: any) => state?.getEventsByStudentScroll
  );

  const tabNumberToType = (tabNumber: number) =>
    Object.values(EventResponse)[tabNumber - 1];

  const loadMoreEvents = (e: React.MouseEvent<HTMLButtonElement>) => {
    setPage((prevPage) => prevPage + 1);
    e.currentTarget.blur();
  };

  useEffect(() => {
    dispatch(
      eventScrollActions.getEventsByStudentScroll(
        tabNumberToType(current),
        page
      )
    );
  }, [page]);

  return (
    <EventListView
      options={WORKSHOPS_OPTIONS}
      handleTab={handleTab}
      selectEvent={selectEvent}
      tabTitle={tabTitle}
      current={current}
      eventType="talleres"
      loadMoreEvents={loadMoreEvents}
      isLoading={isLoading}
      showMore={showMore}
      data={data}
    />
  );
};

export default Workshops;
